import { FieldDescriptor } from './field-descriptor';
import { FieldSizeDescriptor } from './field-size-descriptor';
import { FieldOptionsDescriptor } from './field-options-descriptor';
import { FormControlType } from '../enums';
import { InlineArrayDescriptor } from './inline-array-descriptor';

export class FormFieldConfig {
    fieldInfo: FieldDescriptor;
    size: FieldSizeDescriptor;
    validators: Array<any>;
    options: FieldOptionsDescriptor;
    inlineOptions: InlineArrayDescriptor;
}
